import React, { useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  MenuItem,
  TextField,
  Grid,
  CircularProgress,
  Box,
  Autocomplete,
  Stack,
  Button,
} from "@mui/material";
import { OBTENER_PERSONAS } from "../../graphql/personas";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useFormik } from "formik";
import Moment from "moment";
import { REPORTESRANGOFECHA } from "../../graphql/reporteador";
import { REPORTE_EGRESOS } from "../../graphql/reporteador";
import {
  OBTENER_CAT_EGRESOS,
  OBTENER_SUB_EGRESOS,
} from "../../graphql/egresos";
const FiltroEgresos = ({ setDatos }) => {
  //Reporte de egresos (Categorias)
  const {
    data: dEgresos,
    loading: lEgresos,
    error: eEgreso,
  } = useQuery(OBTENER_CAT_EGRESOS);
  const [obtenerDetallesEgresos, { data: d, loading: l, error: e }] =
    useLazyQuery(OBTENER_SUB_EGRESOS, {});
  const [reporteCobrosPorDia, { loading, error, data }] =
    useLazyQuery(REPORTE_EGRESOS);
  const formik = useFormik({
    initialValues: {
      
      fechaInicio: "",
      fechaFin: "",
      CatEgresosId: "",
      detalleEgresoId: "",
    },
    onSubmit: async (inputData) => {
      try {
        if (inputData.fechaFin < inputData.fechaInicio) {
          throw Error("La fecha de Fin no puede ser menor a la de inicio");
        }
        const datos = await reporteCobrosPorDia({
          variables: {
            fechaInicio: inputData.fechaInicio,
            fechaFin: inputData.fechaFin,
            CatEgresosId: inputData.CatEgresosId,
            detalleEgresoId: inputData.detalleEgresoId
          },
        });
        console.log(datos.data.reporteEgresos);
        setDatos(datos.data.reporteEgresos);
      } catch (error) {
        console.log(error);
      }

      console.log(inputData);
      // try {
      //   if (inputData.fechaInicio > inputData.fechaFin) {
      //     throw Error("La fecha de Inicio no puede ser mayor a la de Fin");
      //   }
      //   const datos = await reportesDelegados({
      //     variables: {
      //       entry: {
      //         fechaInicio: inputData.fechaInicio,
      //         fechaFin: inputData.fechaFin,
      //         PersonaId: parseInt(inputData.PersonaId),
      //       },
      //     },
      //   });

      //   setDatos(datos.data.reportesDelegados);
      //   setOpenDialog(false);
      //   setTitle(
      //     `Reporte de la fecha ${Moment(inputData.fechaInicio).format(
      //       "DD-MMMM-YYYY"
      //     )} a la fecha ${Moment(inputData.fechaFin).format("DD-MMMM-YYYY")}`
      //   );
      // } catch (error) {
      //   console.log(error);
      // }
    },
  });

  const [detalleid, setDetalleId] = useState("");

  const {
    data: personadata,
    loading: personaloading,
    error: personaerror,
  } = useQuery(OBTENER_PERSONAS);

  useEffect(() => {
    console.log(formik.values.CatEgresosId);
    if (formik.values.CatEgresosId == "") {
      setDetalleId("");
    } else {
      setDetalleId(formik.values.CatEgresosId);
    }
    obtenerDetallesEgresos({
      variables: {
        CatEgresos: detalleid,
      },
    });
  }, [setDetalleId, detalleid, formik.values.CatEgresosId]);

  if (personaloading)
  
    return (
      <>
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </>
    );
    

  if (lEgresos) return <h1>Cargando Información...</h1>;
  if (l) return

  const { obtenerPersonas } = personadata;
  const { obtenerCategoriasEgresos } = dEgresos;
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <TextField
              name="CatEgresosId"
              select
              label="Tipo de Egreso"
              helperText="Seleccione una categoría para este registro"
              variant="standard"
              fullWidth
              value={formik.values.CatEgresosId}
              onChange={formik.handleChange}
            >
              {obtenerCategoriasEgresos.map((opcion) => (
                <MenuItem key={opcion.clave} value={opcion.clave}>
                  {opcion.clave}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <TextField
              name="detalleEgresoId"
              select
              label="Subtipo de Egreso"
              helperText="Selecciona un subtipo para el egreso"
              value={formik.values.detalleEgresoId}
              onChange={formik.handleChange}
              variant="standard"
              fullWidth
            >
              {d.obtenerDetallesEgresos.map((options) => (
                  <MenuItem key={options.clave} value={options.clave}>
                    {options.clave} - {options.descripcion}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={12} lg={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                onChange={(date) => formik.setFieldValue("fechaInicio", date)}
                value={formik.values.fechaInicio}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="fechaInicio"
                    fullWidth
                    variant="standard"
                    label="Fecha de Inicio"
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                onChange={(date) => formik.setFieldValue("fechaFin", date)}
                value={formik.values.fechaFin}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="fechaFin"
                    fullWidth
                    variant="standard"
                    label="Fecha de Fin"
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Stack direction="row" alignItems="center" sx={{ my: 2 }}>
          <Button type="submit">Filtrar</Button>
        </Stack>
      </form>
    </>
  );
};

export default FiltroEgresos;
